import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Customer } from "../../models/Customers/Customer";
import { CustomerSettings } from "../../models/Customers/CustomerSettings";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Create order form
 */

export class CartForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Имя',
      name: 'firstName'
    }, {
      label: 'Фамилия',
      name: 'lastName'
    }, {
      label: 'Телефон',
      name: 'phone',
      props: {
        common: {
          maskType: BaseForm.MASK_TYPES.PHONE
        },
        native: {
          keyboardType: 'number-pad'
        }
      }
    }, {
      label: 'E-mail',
      name: 'email'
    }, {
      label: 'Способ доставки',
      name: 'deliveryMethod',
      type: BaseForm.TYPES.DROPDOWN
    }, {
      label: 'Населенный пункт',
      name: 'cityId',
      type: BaseForm.TYPES.AUTOCOMPLETE,
      props: {
        common: {
          dataState: StateSelector.cities.list,
          dataFetch: DispatchSelector.cities.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            }
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        },
        native: {
          renderItem: {
            key: 'list',
            value: 'id',
            label: 'title'
          }
        }
      }
    }, {
      label: 'Улица',
      name: 'street'
    }, {
      label: 'Дом',
      name: 'house',
      props: {
        native: {
          keyboardType: 'number-pad'
        }
      }
    }, {
      label: 'Корпус',
      name: 'block',
      props: {
        native: {
          keyboardType: 'number-pad'
        }
      }
    }, {
      label: 'Квартира',
      name: 'apartment',
      props: {
        native: {
          keyboardType: 'number-pad'
        }
      }
    }, {
      label: 'Дата и время доставки',
      name: 'deliveryPeriod',
      type: BaseForm.TYPES.CUSTOM
    }, {
      label: 'Время доставки',
      name: 'desiredTime',
      type: BaseForm.TYPES.INPUT,
      props: {
        common: {
          maskType: BaseForm.MASK_TYPES.TIME_INTERVAL
        }
      }
    }, {
      label: 'Способ оплаты',
      name: 'paymentMethod',
      type: BaseForm.TYPES.DROPDOWN
    }, {
      label: 'Комментарий',
      name: 'comment',
      props: {
        native: {
          multiline: true
        }
      }
    }];

    this.setDefaultValues = (...models) => {
      models.map(model => {
        if (!model) {
          return;
        }

        switch (model.constructor) {
          case Customer:
            this.setDefault('firstName', model.getFirstName());
            this.setDefault('lastName', model.getLastName());
            this.setDefault('phone', model.getPhone());
            this.setDefault('email', model.getSettings().getEmail());
            break;

          case CustomerSettings:
            this.setDefault('email', model.getEmail());
            break;
        }
      });
      return this;
    };
  }

}